import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Link, useParams } from 'react-router-dom'
import { withStyles } from '@mui/styles'
import { Container, Typography, Icon, Box, CircularProgress } from '@mui/material'

import { useAjaxContext } from '../../../core/ajax/contexts'
import { ThemeButton } from '../../../ui'
import { signupConfirmationStyles } from './signup-confirmation.styles'
import { ERROR_CODES } from '../constants'

const ADHESION_REDIRECT_KEY = 'apins-adhesion-redirect'

export const SignupConfirmationPage = withStyles(signupConfirmationStyles)(({ classes }) => {
  const { formatMessage } = useIntl()
  const { signupToken } = useParams()
  const { signupConfirm } = useAjaxContext()

  const [isLoading, setIsLoading] = useState(true)
  const [success, setSuccess] = useState(false)
  const [message, setMessage] = useState('')

  const [redirectButton, setRedirectButton] = useState(null)

  useEffect(() => {
    signupConfirm(signupToken)
      .then(() => {
        setSuccess(true)
        setRedirectButton('continuar-adhesion')
        setIsLoading(false)
      })
      .catch(({ response }) => {
        const errorCode = response.data.code
        setMessage(ERROR_CODES[errorCode]?.message || 'Ha ocurrido un error')
        setRedirectButton(ERROR_CODES[errorCode]?.redirectTo)
        setIsLoading(false)
      })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleAdhesionButtonClick = () => {
    sessionStorage.setItem(ADHESION_REDIRECT_KEY, '/profile/company')
  }

  return isLoading ? (
    <Box display="flex" height="100%" justifyContent="center" alignItems="center">
      <CircularProgress size={40} />
    </Box>
  ) : (
    <div className={classes.root}>
      <Container className={classes.container} maxWidth="md">
        <div className={classes.panel}>
          <Icon color={success ? 'primary' : 'secondary'} className={classes.icon}>
            {success ? 'check_circle' : 'error'}
          </Icon>
          <div className={classes.content}>
            <Typography variant="h4" paragraph>
              {success ? formatMessage({ id: 'pages.signup.confirmation.success.title' }) : 'Error'}
            </Typography>
            {message && (
              <Typography variant="h6" paragraph>
                {/* {formatMessage({ id: 'pages.signup.confirmation.success.description' })} */}
                {message}
              </Typography>
            )}
          </div>
          {redirectButton && (
            <Link
              className={classes.button}
              to={redirectButton === 'continuar-adhesion' ? '/login' : `/${redirectButton}`}
              replace
              onClick={
                redirectButton === 'continuar-adhesion' ? handleAdhesionButtonClick : undefined
              }
            >
              <ThemeButton type="submit" color="secondary">
                {formatMessage({ id: `pages.signup.redirect.button.${redirectButton}.label` })}
              </ThemeButton>
            </Link>
          )}
        </div>
      </Container>
    </div>
  )
})
